var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.5 15.0754C1.5 21.7871 6.37463 27.3682 12.75 28.5V18.7496H9.375V15H12.75V11.9996C12.75 8.62463 14.9246 6.75037 18.0004 6.75037C18.9746 6.75037 20.0254 6.9 20.9996 7.04962V10.5H19.275C17.6246 10.5 17.25 11.3246 17.25 12.3754V15H20.85L20.2504 18.7496H17.25V28.5C23.6254 27.3682 28.5 21.7882 28.5 15.0754C28.5 7.60875 22.425 1.5 15 1.5C7.575 1.5 1.5 7.60875 1.5 15.0754Z","fill":"current"}));
}

FacebookInline.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
